import { render, staticRenderFns } from "./TaxProfile.vue?vue&type=template&id=8647b164"
import script from "./TaxProfile.vue?vue&type=script&lang=js"
export * from "./TaxProfile.vue?vue&type=script&lang=js"
import style0 from "./TaxProfile.vue?vue&type=style&index=0&id=8647b164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports